import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { FileText } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function downloadListingPdf(id, prices = true) {
  const res = await axios.get(`${API}/listings/${id}/pdf`, { params: { prices }, responseType: "blob", withCredentials: true });
  const name = (res.headers["content-disposition"] || "").match(/filename="([^"]+)"/)?.[1] || "matchappart-annonce.pdf";
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
}

export function PdfButton({ id, withPriceOption = false, testid, className = "" }) {
  const [busy, setBusy] = useState(false);
  const [prices, setPrices] = useState(true);
  const run = async () => {
    setBusy(true);
    try {
      await downloadListingPdf(id, prices);
    } catch {
      toast.error("Impossible de générer la fiche PDF");
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className={`inline-flex items-center gap-2 ${className}`}>
      <button
        type="button"
        onClick={run}
        disabled={busy}
        title="Télécharger la fiche de présentation (PDF)"
        className="inline-flex items-center gap-1.5 px-3 py-2 rounded-md border border-[#E5E1D8] bg-white text-sm text-[#7A3B2A] hover:bg-[#FBF1EE] transition-colors disabled:opacity-50"
        data-testid={testid}
      >
        <FileText className="w-4 h-4" /> {busy ? "Génération…" : "PDF"}
      </button>
      {withPriceOption && (
        <label className="text-xs text-[#666] inline-flex items-center gap-1 cursor-pointer">
          <input type="checkbox" checked={prices} onChange={(e) => setPrices(e.target.checked)} className="accent-[#8C6C50]" data-testid={`${testid}-prices`} />
          tarifs
        </label>
      )}
    </div>
  );
}

export function NeighborhoodFields({ v, set, inp }) {
  const fields = [
    ["neighborhood_ambiance", "Ambiance du quartier", "Animé, résidentiel, quartier d'affaires…"],
    ["neighborhood_shops", "Commerces à proximité", "Supermarchés, boulangeries, restaurants…"],
    ["neighborhood_transport", "Transports utiles", "Métro, tram, gare, axes routiers…"],
  ];
  return (
    <div className="border border-[#E5E1D8] rounded-md p-4 bg-[#FBFAF7]" data-testid="editor-neighborhood">
      <span className="text-xs tracking-[0.15em] uppercase font-semibold text-[#666]">Le quartier (affiché sur l'annonce et la fiche PDF)</span>
      <p className="text-xs text-[#888] mt-1">À saisir ici ou via les colonnes neighborhood_ambiance, neighborhood_shops et neighborhood_transport du fichier d'import.</p>
      <div className="mt-3 space-y-3">
        {fields.map(([k, label, ph]) => (
          <label key={k} className="block">
            <span className="text-xs text-[#666]">{label}</span>
            <textarea rows={3} maxLength={1500} value={v[k] || ""} onChange={(e) => set(k, e.target.value)} placeholder={ph} className={`${inp} mt-1`} data-testid={`editor-${k}`} />
          </label>
        ))}
      </div>
    </div>
  );
}
